import { atom } from "jotai";

export const visibleModalAlertaAtom = atom(false);
export const openModalRegistrarAsistenciaAtom = atom(false);
export const asistenciaSeleccionadaAtom = atom(undefined);
export const asistenciaAtom = atom(undefined);
export const formInstanceAtom = atom(undefined);